import React from 'react';
import SimpleLogReview from './SimpleLogReview';

// One small wrapper per "simple log" module, each just supplying the bits
// that differ (which fields to show, always visible — no click needed) to
// the shared SimpleLogReview shell.

export const ReflectionsReview = ({ ugBatches }) => (
  <SimpleLogReview
    ugBatches={ugBatches}
    title="Reflections Review"
    apiPath="reflections"
    listKey="reflections"
    getStudent={(item) => item.studentId}
    renderBody={(item) => (
      <>
        <div className="ugtr-info-item">
          <span className="ugtr-info-label">Type</span>
          <span className="ugtr-info-value">{item.type}</span>
        </div>
        <div className="ugtr-info-item">
          <span className="ugtr-info-label">Period</span>
          <span className="ugtr-info-value">{item.period}</span>
        </div>
        <div className="ugtr-info-item">
          <span className="ugtr-info-label">Date</span>
          <span className="ugtr-info-value">{new Date(item.date).toLocaleDateString()}</span>
        </div>
        <div className="ugtr-info-item ugtr-entry-body-full">
          <span className="ugtr-info-label">Reflection</span>
          <span className="ugtr-info-value">{item.reflectionText}</span>
        </div>
        {item.learningOutcome && (
          <div className="ugtr-info-item ugtr-entry-body-full">
            <span className="ugtr-info-label">Learning Outcome</span>
            <span className="ugtr-info-value">{item.learningOutcome}</span>
          </div>
        )}
      </>
    )}
  />
);

export const ElectivesReview = ({ ugBatches }) => (
  <SimpleLogReview
    ugBatches={ugBatches}
    title="Electives Review"
    apiPath="electives"
    listKey="electives"
    getStudent={(item) => item.studentId}
    renderBody={(item) => (
      <>
        <div className="ugtr-info-item">
          <span className="ugtr-info-label">Department</span>
          <span className="ugtr-info-value">{item.department}</span>
        </div>
        <div className="ugtr-info-item">
          <span className="ugtr-info-label">Dates</span>
          <span className="ugtr-info-value">
            {new Date(item.fromDate).toLocaleDateString()} - {new Date(item.toDate).toLocaleDateString()}
          </span>
        </div>
        {item.activitiesPerformed && (
          <div className="ugtr-info-item ugtr-entry-body-full">
            <span className="ugtr-info-label">Activities Performed</span>
            <span className="ugtr-info-value">{item.activitiesPerformed}</span>
          </div>
        )}
        {item.learningOutcomes && (
          <div className="ugtr-info-item ugtr-entry-body-full">
            <span className="ugtr-info-label">Learning Outcomes</span>
            <span className="ugtr-info-value">{item.learningOutcomes}</span>
          </div>
        )}
      </>
    )}
  />
);

export const EceReview = ({ ugBatches }) => (
  <SimpleLogReview
    ugBatches={ugBatches}
    title="ECE Review"
    apiPath="ece"
    listKey="sessions"
    getStudent={(item) => item.studentId}
    renderBody={(item) => (
      <>
        <div className="ugtr-info-item">
          <span className="ugtr-info-label">Exposure Type</span>
          <span className="ugtr-info-value">{item.exposureType}</span>
        </div>
        <div className="ugtr-info-item">
          <span className="ugtr-info-label">Date</span>
          <span className="ugtr-info-value">{new Date(item.date).toLocaleDateString()}</span>
        </div>
        <div className="ugtr-info-item">
          <span className="ugtr-info-label">Site</span>
          <span className="ugtr-info-value">{item.departmentOrSite}</span>
        </div>
        <div className="ugtr-info-item">
          <span className="ugtr-info-label">Linked Subject</span>
          <span className="ugtr-info-value">{item.linkedSubject}</span>
        </div>
        <div className="ugtr-info-item ugtr-entry-body-full">
          <span className="ugtr-info-label">Topic</span>
          <span className="ugtr-info-value">{item.topic}</span>
        </div>
        {item.learningPoints && (
          <div className="ugtr-info-item ugtr-entry-body-full">
            <span className="ugtr-info-label">Learning Points</span>
            <span className="ugtr-info-value">{item.learningPoints}</span>
          </div>
        )}
        {item.reflection && (
          <div className="ugtr-info-item ugtr-entry-body-full">
            <span className="ugtr-info-label">Reflection</span>
            <span className="ugtr-info-value">{item.reflection}</span>
          </div>
        )}
      </>
    )}
  />
);

export const FapReview = ({ ugBatches }) => (
  <SimpleLogReview
    ugBatches={ugBatches}
    title="FAP Review"
    apiPath="fap/visits"
    listKey="visits"
    getStudent={(item) => item.studentId}
    renderBody={(item) => (
      <>
        <div className="ugtr-info-item">
          <span className="ugtr-info-label">Family</span>
          <span className="ugtr-info-value">{item.familyId?.familyCode} — {item.familyId?.villageName}</span>
        </div>
        <div className="ugtr-info-item">
          <span className="ugtr-info-label">Visit Date</span>
          <span className="ugtr-info-value">{new Date(item.visitDate).toLocaleDateString()}</span>
        </div>
        <div className="ugtr-info-item">
          <span className="ugtr-info-label">Program Year</span>
          <span className="ugtr-info-value">{item.programYear}</span>
        </div>
        <div className="ugtr-info-item ugtr-entry-body-full">
          <span className="ugtr-info-label">Purpose</span>
          <span className="ugtr-info-value">{item.purpose}</span>
        </div>
        {item.findings && (
          <div className="ugtr-info-item ugtr-entry-body-full">
            <span className="ugtr-info-label">Findings</span>
            <span className="ugtr-info-value">{item.findings}</span>
          </div>
        )}
        {item.healthEducationGiven && (
          <div className="ugtr-info-item ugtr-entry-body-full">
            <span className="ugtr-info-label">Health Education Given</span>
            <span className="ugtr-info-value">{item.healthEducationGiven}</span>
          </div>
        )}
        {item.referralMade && (
          <div className="ugtr-info-item ugtr-entry-body-full">
            <span className="ugtr-info-label">Referral Made</span>
            <span className="ugtr-info-value">{item.referralMade}</span>
          </div>
        )}
        {item.reflection && (
          <div className="ugtr-info-item ugtr-entry-body-full">
            <span className="ugtr-info-label">Reflection</span>
            <span className="ugtr-info-value">{item.reflection}</span>
          </div>
        )}
      </>
    )}
  />
);

export const ConferenceReview = ({ ugBatches }) => (
  <SimpleLogReview
    ugBatches={ugBatches}
    title="Conference Review"
    apiPath="conference"
    listKey="entries"
    getStudent={(item) => item.studentId}
    renderBody={(item) => (
      <>
        <div className="ugtr-info-item">
          <span className="ugtr-info-label">Event</span>
          <span className="ugtr-info-value">{item.title} ({item.eventType})</span>
        </div>
        <div className="ugtr-info-item">
          <span className="ugtr-info-label">Mode</span>
          <span className="ugtr-info-value">{item.mode}</span>
        </div>
        <div className="ugtr-info-item">
          <span className="ugtr-info-label">Role</span>
          <span className="ugtr-info-value">{item.role}</span>
        </div>
        <div className="ugtr-info-item">
          <span className="ugtr-info-label">Certificate</span>
          <span className="ugtr-info-value">{item.certificateReceived ? 'Yes' : 'No'}</span>
        </div>
        {item.topic && (
          <div className="ugtr-info-item ugtr-entry-body-full">
            <span className="ugtr-info-label">Topic</span>
            <span className="ugtr-info-value">{item.topic}</span>
          </div>
        )}
        {item.keyLearnings && (
          <div className="ugtr-info-item ugtr-entry-body-full">
            <span className="ugtr-info-label">Key Learnings</span>
            <span className="ugtr-info-value">{item.keyLearnings}</span>
          </div>
        )}
      </>
    )}
  />
);

export const InternshipActivityReview = ({ ugBatches }) => (
  <SimpleLogReview
    ugBatches={ugBatches}
    title="Internship Review"
    apiPath="internship/activities"
    listKey="activities"
    getStudent={(item) => item.studentId}
    renderBody={(item) => (
      <>
        <div className="ugtr-info-item">
          <span className="ugtr-info-label">Procedure/Case</span>
          <span className="ugtr-info-value">{item.procedureOrCase}</span>
        </div>
        <div className="ugtr-info-item">
          <span className="ugtr-info-label">Involvement</span>
          <span className="ugtr-info-value">{item.involvementLevel}</span>
        </div>
        <div className="ugtr-info-item">
          <span className="ugtr-info-label">Posting</span>
          <span className="ugtr-info-value">{item.postingId?.department}</span>
        </div>
        <div className="ugtr-info-item">
          <span className="ugtr-info-label">Date</span>
          <span className="ugtr-info-value">{new Date(item.date).toLocaleDateString()}</span>
        </div>
        {item.caseSummary && (
          <div className="ugtr-info-item ugtr-entry-body-full">
            <span className="ugtr-info-label">Case Summary</span>
            <span className="ugtr-info-value">{item.caseSummary}</span>
          </div>
        )}
        {item.learningPoints && (
          <div className="ugtr-info-item ugtr-entry-body-full">
            <span className="ugtr-info-label">Learning Points</span>
            <span className="ugtr-info-value">{item.learningPoints}</span>
          </div>
        )}
      </>
    )}
  />
);
